import React from 'react'
 
function CheckEmailModal(props) {
  const { error, handleDone } = props;
  return (
    <div>
      <div 
        className="modal fade"
        id="checkEmailModal" 
        tabIndex="-1" 
        role="dialog"
        aria-labelledby="checkEmailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              {error ? 
                <div>
                  <h2 className="text-center text-danger mb-4">Failed to register tenant.</h2>
                  <p className="text-center">{error}</p>
                </div>
              :
                // <div>
                //   <h2 className="text-center text-success mb-4">Email successfully sent!</h2> 
                //   <p className="text-center">Please check your email for the link to reset your password.</p>
                // </div>
                <div>
                  <h2 className="text-center text-success mb-4">Tenant successfully registered!</h2> 
                </div>
              }
              <div className="row justify-content-center">
                <button type='button' id="doneBtn" className='btn btn-primary btn-block mb-1' onClick={handleDone}>Done</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" id="backdrop" style={{display: "none"}}></div>
    </div>
  )
}

export default CheckEmailModal